import { useSearchParams } from 'react-router-dom';

import {
  useFilteredTemplatesListQuery,
  useTemplateSectionsQuery,
  WaypointTemplateType,
} from '@dashboard/generated/wp/platform';

export function useCurrentTemplateSections() {
  return useTemplateSectionsQuery();
}

export function useIsLayoutTab() {
  const [params] = useSearchParams();
  const typeValue = params.get('type');
  return typeValue === 'LAYOUT';
}

export function useCurrentTemplatesQuery() {
  const [params] = useSearchParams();
  const pageValue = params.get('page');
  const isLayoutTab = useIsLayoutTab();

  return useFilteredTemplatesListQuery({
    fetchPolicy: 'network-only',
    variables: {
      type: isLayoutTab ? WaypointTemplateType.Layout : WaypointTemplateType.Template,
      page: pageValue === null ? undefined : parseInt(pageValue, 10),
    },
  });
}
